import { axiosAssessmentInstance } from "../AxiosConfiguration";

/**
 * v3 assessment engine — the live Discovery engine (core-lambda
 * assessment_module/v3). Discoveries are taken by legacy category name
 * (D1→Identity, D2→Cognition, D3→Resolution, D4→Motivation); D5 is derived
 * and never taken. Questions are Likert: an `options` map keyed SA/A/N/D/SD,
 * answered with `answer_id: ["<key>"]`.
 *
 * Completion is synchronous: with `auto_submit` (the default), answering the
 * final question returns `{ isLastResponse: true, categoryName,
 * aris_elements: { <legacy domain>: [...] }, all_tests_completed }` — the
 * unlocked elements arrive in the same response. `all_tests_completed` is a
 * hint only (it can be vacuously true); `discovery-progress.all_complete` is
 * the authority for foundation completion.
 */

const unwrap = (res) => {
  const data = res?.data;
  if (data && typeof data === "object") return data.payload ?? data;
  return data;
};

/** discovery_key → what the v3 engine and the periodic table call it. */
export const DISCOVERY_RUNTIME = {
  D1_HOW_YOU_SHOW_UP: { categoryName: "Identity", domain: "IDENTITY" },
  D2_HOW_YOU_THINK: { categoryName: "Cognition", domain: "COGNITION" },
  D3_HOW_YOU_HANDLE_CONFLICT: { categoryName: "Resolution", domain: "RESOLUTION" },
  D4_WHAT_DRIVES_YOU: { categoryName: "Motivation", domain: "MOTIVES" },
  // D5 is derived — it has no runner and must never be initiated.
};

export const initiateDiscovery = async (categoryName) => {
  const res = await axiosAssessmentInstance.post("/api/v3/assessment/initiate", {
    item_type: "category",
    category_name: categoryName,
    create: 1,
    is_survey: false,
  });
  return unwrap(res);
};

export const nextDiscoveryAnswer = async (body) => {
  const res = await axiosAssessmentInstance.post(
    "/api/v3/assessment/answers/next",
    body
  );
  return unwrap(res);
};

export const prevDiscoveryQuestion = async (body) => {
  const res = await axiosAssessmentInstance.post(
    "/api/v3/assessment/questions/prev",
    body
  );
  return unwrap(res);
};
